import $ST from 'plugins/tfs/platformConfigs/staticTextMaps/customer';
import $R from 'plugins/tfs/platformConfigs/integrationMaps/routes';
import React, { useMemo } from 'react';
import { Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Button from 'theme/Button';
import Modal from 'theme/Modal';
import ModalSpinner from 'theme/ModalSpinner';
import SmsVerificationModal from 'components/partials/SmsVerificationModal';
import Error from 'theme/Error';

// pageContainer
import CustomerDetail from '_pageContainers/customer/customerDetail';

const CustomerDetailGrid = (pageContext) => {
  const dispatch = useDispatch();

  const {
    props: {
      smsExpireDate,
      hideModalAction,
      smsModalVisibility,
      signInRequest,
      smsError,
      customer,
      pending,
      error,
      redirect,
    },
    customerPk,
    attemptForSignIn,
  } = pageContext;

  const { phone } = customer;

  const customerPhone = useMemo(() => {
    if (Boolean(phone)) {
      const last4Digit = phone.slice(-4);
      const asterisks = Array.from('*'.repeat(phone.slice(0, -4).length)).join(
        ''
      );
      return `${asterisks}${last4Digit}`;
    }
    return $ST.NOT_ENTERED;
  }, [phone]);

  if (customerPk === customer.pk && redirect) {
    return <Redirect to={$R.BASKET.path} />;
  }

  return (
    <div className='container-fluid customer-info headerMargin'>
      {smsModalVisibility && (
        <Modal onClose={() => dispatch(hideModalAction())} width={70}>
          <SmsVerificationModal
            error={{ ...smsError, code: smsError.smsCode }}
            expire={smsExpireDate}
            onEnter={(smsCode) =>
              dispatch(signInRequest({ ...customer, smsCode }))
            }
          />
        </Modal>
      )}

      {!pending && error.message && error.message}
      {pending && <ModalSpinner />}
      {!pending && !error.message && (
        <div className='row'>
          <div className='col-12 col-md-12'>
            <div className='customer-info__left'>
              <div className='customer-info__left__container bordered'>
                <div className='title_wrapper'>
                  <h1>
                    {customer.first_name} {customer.last_name}
                  </h1>
                </div>
                <p>
                  {$ST.PHONE}: {customerPhone}
                </p>
                <p>
                  {$ST.EMAIL}: {customer.email}
                </p>
              </div>

              <div className='customer-info__left__container'>
                <Button
                  classes='button customer-info__left__container__button pointer'
                  onClick={() => {
                    attemptForSignIn();
                  }}
                >
                  {$ST.SELECT_THIS_CUSTOMER}
                </Button>
                <Error data={error} field='phone_number' />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerDetail(CustomerDetailGrid);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/customer/customerDetail/index.js